import React, { useEffect, useState } from "react";
import "./crewProfile.css";
import axios from "axios";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { CircularProgress, Backdrop } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { getData } from "country-list";
import Tesseract from "tesseract.js";
import * as pdfjsLib from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf";
import worker from "pdfjs-dist/build/pdf.worker.entry";
import { Table, TableHead, TableRow, TableBody, } from "@mui/material";
GlobalWorkerOptions.workerSrc = worker;
// Set worker from CDN
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

import {
  Container,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Box,
  Paper,
  TableCell,
  Autocomplete
} from "@mui/material";

const CrewProfile = () => {
  const location = useLocation();
  const userId = localStorage.getItem("user id");

  const userType = localStorage.getItem("userType");
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState(
    location.state?.crewProfile || {
      indosno: "",
      name: "",
      email: "",
      mobile: "",
      gender: "",
      placOfBirth: "",
      dateofBirth: "",
      birthCountry: "",
      birthState: "",
      nationality: "",
      rankname: "",
      purpose: "",
      cdc: "",
      coc: "",
      cvcategory: "",
      passport: "",
      presentAddress: "",
      height: "",
      hairColor: "",
      eyeColor: "",
      Complexion: "",
      identificationMark: "",
      NOK: [
        {
          name: "",
          relation: "",
          mobile: "",
          email: "",
          percentage: "",
          bankdetails: [
            {
              bankName: "",
              accountNo: "",
              branch: "",
              ifsc: "",
            },
          ],
        },
      ],
      experiences: [  // ✅ Added this array for multiple experience entries
        {
          vessel: "",
          type: "",
          company: "",
          rank: "",
          tradeArea: "",
          grt: "",
          joiningDate: "",
          signOffDate: "",
        },
      ],
    }
  );

  const [ranks, setRankData] = useState([]);
  const [requiredDocuments, setRequiredDocuments] = useState([]);
  const navigate = useNavigate();
  const crewProfileID = location.state?.crewProfile?._id;
  const fromPage = location.state?.from || "CrewInfo";
  const [documents, setDocuments] = useState({}); // Stores uploaded files
  const [loading, setLoading] = useState(false);
  // const [token, setToken] = useState("")
  const [requiredDocumentsLoading, setRequiredDocumentsLoading] =
    useState(false);

  const [parsedText, setParsedText] = useState("");
  function extractFieldsFromText(text) {
    const nameMatch = text.match(/NAME\s*:\s*MR\.?\s*((?:[A-Z]+\s+){1,4}[A-Z]+)(?=\s+(FATHER|DATE|RANK|NATIONALITY|$))/i);
    const rankMatch = text.match(/RANK\s+APPLIED\s+FOR\s*:\s*([A-Z\s]+?)(?=\s+(NAME|DATE|NATIONALITY|CONTACT|EMAIL|$))/i);
    const dobMatch = text.match(/DATE OF BIRTH\s*:\s*(\d{2}[\/-]\d{2}[\/-]\d{4})/i);
    const nationalityMatch = text.match(/NATIONALITY\s*:\s*([A-Z]+)/i);
    const phoneMatch = text.match(/CONTACT NO\.?\s*:\s*([+\d\s,\/]+)/i);
    const emailMatch = text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
    const indosMatch = text.match(/INDOS\s+([A-Z0-9]+)/i);
    const passportMatch = text.match(/PASSPORT\s+([A-Z0-9]+)/i);
    const cdcMatch = text.match(/C\.?\s*D\.?\s*C\.?\s*[\s:.-]*([A-Z]{3}\s*\d{6})/i);
    const birthCountryMatch = text.match(/BIRTH COUNTRY\s*:\s*([A-Z\s]+)/i);
    const nationality = nationalityMatch ? nationalityMatch[1].trim().toLowerCase() : '';
    let birthCountry = birthCountryMatch ? birthCountryMatch[1].trim().toLowerCase() : '';
    const rankname = rankMatch ? rankMatch[1].trim() : '';
    const fallbackNameMatch = text.match(/NAME\s*:\s*(MR\.?\s*)?([A-Z\s]+)/i);
    const fallbackRankMatch = text.match(/POST\s+APPLIED\s+FOR\s*:\s*([A-Z\s]+)/i);
    const addressMatch = text.match(/ADDRESS\s*[:\-]?\s*([\s\S]+?)(?=(EDUCATIONAL|DOCUMENT|PROFESSIONAL|CURRICULUM))/i);

    // Override birthCountry if nationality is "indian"
    if (nationality === 'indian') {
      birthCountry = 'india';
    }

    // Step 1: Flatten experiences
    const experienceSection = text.split('\n')
      .filter(line => line.trim() !== '') // remove empty lines
      .join(' ')                           // join all into one line
      .replace(/\s{2,}/g, ' ');           // normalize spacing for regex

    const experienceRegex = /(\d+)\s*\.\s+(.+?)\s{2,}(.+?)\s{2,}(.+?)\s{2,}(AB|OS|TR\.?OS)\s+([\w\/-]+)\s+(\d+)\s+(\d{2}\/\d{2}\/\d{4})\s+(\d{2}\/\d{2}\/\d{4})/gi;

    const experiences = [];
    let match;
    while ((match = experienceRegex.exec(experienceSection)) !== null) {
      experiences.push({
        vessel: match[2].trim(),
        type: match[3].trim(),
        company: match[4].trim(),
        rank: match[5].replace('TR.', 'TRAINEE').trim(),
        tradeArea: match[6].trim(),
        grt: match[7].trim(),
        joiningDate: formatDate(match[8].trim()),
        signOffDate: formatDate(match[9].trim()),
      });
    }

    function formatDate(dateStr) {
      const [dd, mm, yyyy] = dateStr.split('/');
      return `${yyyy}-${mm}-${dd}`;
    }

    return {
      name: nameMatch ? nameMatch[1].trim() : fallbackNameMatch ? fallbackNameMatch[2].trim() : '',
      rankname: rankMatch ? rankMatch[1].trim() : fallbackRankMatch ? fallbackRankMatch[1].trim() : '',
      dateofBirth: dobMatch ? dobMatch[1].replace(/-/g, '/') : '',
      nationality,
      mobile: phoneMatch ? phoneMatch[1].replace(/\s+/g, '').split(/[\/,]/)[0] : '',
      alternateMobile: phoneMatch ? phoneMatch[1].replace(/\s+/g, '').split(',')[1] || '' : '',
      email: emailMatch ? emailMatch[0] : '',
      indosno: indosMatch ? indosMatch[1] : '',
      passport: passportMatch ? passportMatch[1] : '',
      cdc: cdcMatch ? cdcMatch[1] : '',
      birthCountry,
      cvcategory: rankname,
      experiences,
      presentAddress: addressMatch ? addressMatch[1].trim().replace(/\s{2,}/g, ' ') : '',

    };

  }

  useEffect(() => {
    if (parsedText) {
      const extractedData = extractFieldsFromText(parsedText);
      setFormData((prev) => ({
        ...prev,
        ...extractedData,
      }));
    }
  }, [parsedText]);

  useEffect(() => {
    fetchRankData();
  }, []);

  useEffect(() => {
    if (!formData.NOK || formData.NOK.length === 0) {
      // Initialize one NOK with one blank bank detail
      setFormData((prev) => ({
        ...prev,
        NOK: [
          {
            name: "",
            relation: "",
            mobile: "",
            email: "",
            percentage: "",
            bankdetails: [
              {
                bankName: "",
                accountNo: "",
                branch: "",
                ifsc: "",
              },
            ],
          },
        ],
      }));
    } else {
      // Ensure every NOK has at least one bankdetails entry
      const updatedNOK = formData.NOK.map((nok) => ({
        ...nok,
        bankdetails: nok.bankdetails && nok.bankdetails.length > 0
          ? nok.bankdetails
          : [
            {
              bankName: "",
              accountNo: "",
              branch: "",
              ifsc: "",
            },
          ],
      }));

      setFormData((prev) => ({
        ...prev,
        NOK: updatedNOK,
      }));
    }
  }, []);

  //  const countryList = Object.entries(countries).map(([code, country]) => ({
  //     code,
  //     name: country.name,
  //   }));

  const countryList = getData();

  // Utility function to format document keys
  const formatDocumentName = (docKey) => {
    return docKey
      // insert space before capital letters
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // uppercase everything
      .toUpperCase();
  };
  const fetchRankData = async () => {
    const token = localStorage.getItem("token");
    try {
      setRequiredDocumentsLoading(true);
      const response = await axios.get(`${baseURL}/api/rankData`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const rankList = response.data.data;

      if (formData.rankname) {
        const selectedRank = rankList.find(
          (rank) => rank.rankname === formData.rankname
        );

      if (selectedRank) {
  const docs = selectedRank.requireddocuments || [];
  setRequiredDocuments(docs); // keep original keys
}
      }

      setRankData(rankList);
      setRequiredDocumentsLoading(false);
    } catch (error) {
      toast.error("Error fetching rank data");
      setError(error?.response?.data?.message);
      setRequiredDocumentsLoading(false);
    }
  };


  // useEffect(() => {
  //   if (formData.rankname) {

  //     const selectedRank = ranks.find(rank => rank.rankname === formData.rankname);
  //     if (selectedRank) {
  //       setRequiredDocuments(selectedRank.requiredDocuments || []);
  //     }
  //   }
  // }, [formData.rankname]);
  const handleFileUpload = async (e, documentType) => {
    const file = e.target.files[0];

    if (!file) return;

    // Append to FormData if needed
    setFormData(prev => ({
      ...prev,
      documents: {
        ...prev.documents,
        [documentType]: file,
      },
    }));

    // Call parser
    if (file.type === "application/pdf") {
      await extractTextFromPDF(file);
    } else if (file.type.startsWith("image/")) {
      await extractTextFromImage(file);
    }
  };

  const extractTextFromPDF = async (file) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const typedarray = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument(typedarray).promise;
      let fullText = "";

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const content = await page.getTextContent();
        const text = content.items.map(item => item.str).join(" ");
        fullText += text + "\n";
      }

      setParsedText(fullText);
      // console.log("Extracted PDF text:", fullText);
    };

    reader.readAsArrayBuffer(file);
  };

  const extractTextFromImage = async (file) => {
    const imageData = URL.createObjectURL(file);

    Tesseract.recognize(imageData, "eng")
      .then(({ data: { text } }) => {
        setParsedText(text);
        // console.log("Extracted Image Text:", text);
      })
      .catch(err => {
        console.error("OCR error:", err);
      });
  };


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
    setDocuments((prevDocs) => ({
      ...prevDocs,
      [name]: files[0],
    }));
  };

  const handleNOKChange = (index, field, value) => {
    setFormData((prevState) => {
      const updatedNOK = prevState.NOK.map((nok, i) =>
        i === index ? { ...nok, [field]: value } : nok
      );
      return { ...prevState, NOK: updatedNOK };
    });
  };

  const handleBankChange = (nokIndex, bankIndex, field, value) => {
    setFormData((prevState) => {
      const updatedNOK = prevState.NOK.map((nok, i) =>
        i === nokIndex
          ? {
            ...nok,
            bankdetails: nok.bankdetails.map((bank, j) =>
              j === bankIndex ? { ...bank, [field]: value } : bank
            ),
          }
          : nok
      );
      return { ...prevState, NOK: updatedNOK };
    });
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Only check required documents on CREATE, not on UPDATE
    const isUpdate = !!crewProfileID;

    if (!isUpdate) {
      // ✅ Fix: Check if all required documents are uploaded (only on create)
      const missingDocs = requiredDocuments.filter((doc) => {
        return !documents[doc] || (!documents[doc].filePath && !(documents[doc] instanceof File));
      });

      if (missingDocs.length > 0) {
        toast.error(`Missing required documents: ${missingDocs.join(", ")}`);
        setLoading(false);
        return;
      }
    }

    // ✅ Fix: Check for missing fields
    const requiredFields = [
      "indosno", "name", "email", "mobile", "gender", "placOfBirth",
      "dateofBirth", "birthCountry", "birthState", "nationality",
      "rankname", "purpose", "cdc", "coc", "cvcategory", "passport",
      "presentAddress",
    ];

    const missingFields = requiredFields.filter(
      (field) => !formData[field] || (typeof formData[field] === "string" && formData[field].trim() === "")
    );

    if (missingFields.length > 0) {
      toast.error(`Missing required fields: ${missingFields.join(", ")}`, {
        position: "top-right",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("creatorIdWithName", userId);

    // Append normal fields
    Object.keys(formData).forEach((key) => {
      if (key !== "NOK" && key !== "experiences" && key !== "documents" && formData[key]) {
        formDataToSend.append(key, formData[key]);
      }
    });

    // Append NOK fields
    if (Array.isArray(formData.NOK)) {
      formData.NOK.forEach((nokItem, index) => {
        formDataToSend.append(`NOK[${index}][name]`, nokItem.name);
        formDataToSend.append(`NOK[${index}][relation]`, nokItem.relation);
        formDataToSend.append(`NOK[${index}][mobile]`, nokItem.mobile);
        formDataToSend.append(`NOK[${index}][email]`, nokItem.email);
        formDataToSend.append(`NOK[${index}][percentage]`, nokItem.percentage);

        if (Array.isArray(nokItem.bankdetails)) {
          nokItem.bankdetails.forEach((bank, bankIndex) => {
            formDataToSend.append(`NOK[${index}][bankdetails][${bankIndex}][bankName]`, bank.bankName);
            formDataToSend.append(`NOK[${index}][bankdetails][${bankIndex}][accountNo]`, bank.accountNo);
            formDataToSend.append(`NOK[${index}][bankdetails][${bankIndex}][branch]`, bank.branch);
            formDataToSend.append(`NOK[${index}][bankdetails][${bankIndex}][ifsc]`, bank.ifsc);
          });
        }
      });
    }

    // ✅ Append experiences array
    if (Array.isArray(formData.experiences)) {
      formData.experiences.forEach((exp, index) => {
        formDataToSend.append(`experiences[${index}][vessel]`, exp.vessel || "");
        formDataToSend.append(`experiences[${index}][type]`, exp.type || "");
        formDataToSend.append(`experiences[${index}][company]`, exp.company || "");
        formDataToSend.append(`experiences[${index}][rank]`, exp.rank || "");
        formDataToSend.append(`experiences[${index}][tradeArea]`, exp.tradeArea || "");
        formDataToSend.append(`experiences[${index}][grt]`, exp.grt || "");
        formDataToSend.append(`experiences[${index}][joiningDate]`, exp.joiningDate || "");
        formDataToSend.append(`experiences[${index}][signOffDate]`, exp.signOffDate || "");
      });
    }


    // ✅ Fix: Append required documents (new files or existing ones)
    requiredDocuments.forEach((doc) => {
      if (!formDataToSend.has(doc) && documents[doc]) {
        if (documents[doc] instanceof File) {
          formDataToSend.append(doc, documents[doc]);
        } else if (documents[doc].filePath) {
          formDataToSend.append(doc, documents[doc].filePath);
        }
      }
    });

    for (let pair of formDataToSend.entries()) {
      // console.log(pair[0], pair[1]);
    }

    // console.log("Final Payload:", Object.fromEntries(formDataToSend.entries()));

    try {
      const token = localStorage.getItem("token");

      const response = crewProfileID
        ? await axios.put(
          `${baseURL}/api/updateCrewProfileDetails/${crewProfileID}`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        : await axios.post(`${baseURL}/api/crewprofile`, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });

      toast.success(response.data.message);
      setLoading(false);

      setTimeout(() => {
        if (userType === "crew") {
          navigate("/login");
        }
        else {
          navigate("/CrewProfileTable");
        }
      }, 1000);
    } catch (err) {
      setLoading(false);
      if (err.response) {
        console.error("Backend Error Response:", err.response.data);
        toast.error(
          `Error: ${err.response.data.message || err.response.data.error}`
        );
      } else {
        console.error("Error:", err.message);
        toast.error("Error", err.message);
      }
    } finally {
      setLoading(false);
    }
  };


  const handleEdit = (id, rankname) => {
    if (!id) {
      console.error("Invalid Rank ID"); // Debugging log
      return;
    }
    navigate(`/AddRank/${id}`, { state: { rankname } });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // Handle form field change
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });

  //   if (name === "rankname") {

  //     const selectedRank = ranks.find(rank => rank.rankname === value);
  //     setRequiredDocuments(selectedRank?.requireddocuments || []);
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "rankname") {
      // Find selected rank details to get required documents
      const selectedRank = ranks.find((rank) => rank.rankname === value);
      // Be consistent with the property name (use requireddocuments with lowercase 'd')
      setRequiredDocuments(selectedRank?.requireddocuments || []);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  return (
    <>
      <Navbar />
      {/* Error message */}
      {error && (
        <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
          <Typography color="error" variant="h6">
            {error}
          </Typography>
        </Box>
      )}


      {/* Fancy Full Screen Loader */}
      {loading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            flexDirection: "column",
          }}
          open={loading}
        >
          <CircularProgress color="inherit" size={60} />
          <Typography variant="h6" color="inherit" sx={{ marginTop: 2 }}>
            Submitting your data...
          </Typography>
        </Backdrop>
      )}
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Distribute items across the row
              padding: "10px 0",
              // maxWidth: "900px",
              position: "relative",
              textAlign: "center",
              width: "100%",
            }}
          >
            {/* Back Button (Left Aligned) */}
            <button
              onClick={() => navigate(-1)}
              className="p-2 bg-blue-500 text-black rounded"
              style={{
                padding: "8px 16px",
              }}
            >
              Back
            </button>

            {/* Title (Centered) */}
            <Typography variant="h4" gutterBottom style={{ flex: 1, textAlign: "center" }}>
              Crew Form
            </Typography>

            {/* Message about adding rank (Right-Aligned) */}
            <Typography
              variant="body1"
              style={{
                color: "red", // Highlight the message
                fontWeight: "bold",
                marginLeft: "auto", // Push it to the right
                textAlign: "right",
              }}
            >
              First add a rank before proceeding.
            </Typography>
          </div>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                width: 250,
                border: "1px solid #ccc",
                padding: 2,
                borderRadius: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                alignSelf: "flex-end", // This pushes the box to the right
              }}
            >
              <Typography variant="body1" fontWeight="bold" gutterBottom>
                Upload CV
              </Typography>

              <input
                type="file"
                accept=".pdf, image/*"
                onChange={(e) => handleFileUpload(e, "uploadedDocument")}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              />
            </Box>

            <Typography
              variant="body2"
              sx={{
                mt: 1,
                alignSelf: "flex-end",
                fontWeight: "bold",
                lineHeight: 1.8, // Adjust for desired spacing
              }}
            >
              Upload your CV in the given format to auto-fill the form. <br />
              You can download the CV format template here:&nbsp;
              <a
                href="/files/CV_format.docx"
                download
                style={{
                  fontWeight: "bold",
                  color: "#1976d2",
                  textDecoration: "none",
                  marginLeft: "4px",
                }}
              >
                Download Word File
              </a>
            </Typography>
          </Box>



          <form onSubmit={handlesubmit}>
            {/* Personal Details Section */}
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Personal Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Indos No."
                  name="indosno"
                  value={formData.indosno}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  helperText="Please use the same email you used during signup."
                  FormHelperTextProps={{
                    sx: { color: 'red' }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <PhoneInput
                  country={"in"} // Default country code (change as needed)
                  value={formData.mobile}
                  onChange={(phone) =>
                    setFormData({ ...formData, mobile: phone })
                  }
                  inputProps={{
                    name: "mobile",
                    required: true,
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "56px", // Match MUI TextField height
                    borderRadius: "4px",
                    border: "1px solid #cbd5e1",
                    fontSize: "16px",
                    paddingLeft: "48px", // Leave room for country selector
                    boxSizing: "border-box",
                    paddingLeft: "52px", // Adjusted for better spacing
                    paddingRight: "14px",
                  }}
                  buttonStyle={{
                    border: "none",
                    backgroundColor: "transparent",
                    left: "12px",
                  }}
                  containerStyle={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                  >
                    <MenuItem value="select">Select</MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Place of Birth"
                  name="placOfBirth"
                  value={formData.placOfBirth}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date of Birth"
                  name="dateofBirth"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={formatDate(formData.dateofBirth)}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  options={countryList}
                  getOptionLabel={(option) => option.name}
                  value={countryList.find((c) => c.name === formData.birthCountry) || null}
                  onChange={(event, newValue) =>
                    handleInputChange({
                      target: {
                        name: "birthCountry",
                        value: newValue ? newValue.name : "",
                      },
                    })
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Birth Country" />
                  )}
                />

              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Birth State"
                  name="birthState"
                  value={formData.birthState}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nationality"
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Purpose"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="CDC No."
                  name="cdc"
                  value={formData.cdc}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="COC No."
                  name="coc"
                  value={formData.coc}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="CV Category"
                  name="cvcategory"
                  value={formData.cvcategory}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Passport"
                  name="passport"
                  value={formData.passport}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>

            {/* Address Section */}
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Address
            </Typography>

            <TextField
              fullWidth
              label="Full Address"
              name="presentAddress"
              value={formData.presentAddress}
              onChange={handleInputChange}
              multiline
              minRows={3}
            />



            {/* Experience Details Section */}
            {formData.experiences && formData.experiences.length > 0 && formData.experiences.some(
              (exp) => Object.values(exp).some((val) => val && val.toString().trim() !== "")
            ) && (
                <>
                  <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                    PROFESSIONAL EXPERIENCES
                  </Typography>
                  <Box sx={{ overflowX: "auto" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Vessel</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Company</TableCell>
                          <TableCell>Rank</TableCell>
                          <TableCell>Trade / Area</TableCell>
                          <TableCell>GRT</TableCell>
                          <TableCell>Date of Joining</TableCell>
                          <TableCell>Date of Sign Off</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {formData.experiences.map((exp, index) => (
                          <TableRow key={index}>
                            <TableCell>{exp.vessel}</TableCell>
                            <TableCell>{exp.type}</TableCell>
                            <TableCell>{exp.company}</TableCell>
                            <TableCell>{exp.rank}</TableCell>
                            <TableCell>{exp.tradeArea}</TableCell>
                            <TableCell>{exp.grt}</TableCell>
                            <TableCell>{exp.joiningDate}</TableCell>
                            <TableCell>{exp.signOffDate}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </>
              )}



            {/* Physical Details Section */}
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Physical Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Height (in cms)"
                  name="height"
                  value={formData.height}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Hair Color"
                  name="hairColor"
                  value={formData.hairColor}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Eye Color"
                  name="eyeColor"
                  value={formData.eyeColor}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Complexion</InputLabel>
                  <Select
                    name="Complexion"
                    value={formData.Complexion}
                    onChange={handleInputChange}
                  >
                    <MenuItem value="">Select Complexion</MenuItem>
                    <MenuItem value="Fair">Fair</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="Dark">Dark</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Identification Mark"
                  name="identificationMark"
                  value={formData.identificationMark}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Next of Kin (NOK) Details
            </Typography>

            {formData.NOK.map((nok, index) => (
              <Grid container spacing={3} key={index}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    value={nok.name}
                    onChange={(e) =>
                      handleNOKChange(index, "name", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Relation"
                    value={nok.relation}
                    onChange={(e) =>
                      handleNOKChange(index, "relation", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <PhoneInput
                    country={"in"}
                    value={nok.mobile}
                    onChange={(phone) =>
                      handleNOKChange(index, "mobile", phone)
                    }
                    inputProps={{ required: true }}
                    inputStyle={{
                      width: "100%",
                      height: "56px", // Match MUI TextField height
                      borderRadius: "4px",
                      border: "1px solid #cbd5e1",
                      fontSize: "16px",
                      paddingLeft: "48px", // Leave room for country selector
                      boxSizing: "border-box",
                      paddingLeft: "52px", // Adjusted for better spacing
                      paddingRight: "14px",
                    }}
                    buttonStyle={{
                      border: "none",
                      backgroundColor: "transparent",
                      left: "12px",
                    }}
                    containerStyle={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={nok.email}
                    onChange={(e) =>
                      handleNOKChange(index, "email", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Percentage"
                    value={nok.percentage}
                    onChange={(e) =>
                      handleNOKChange(index, "percentage", e.target.value)
                    }
                  />
                </Grid>

                {/* Add NOK Button */}
                {/* <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setFormData({
                        ...formData,
                        NOK: [
                          ...formData.NOK,
                          {
                            name: "",
                            relation: "",
                            mobile: "",
                            email: "",
                            percentage: "",
                            bankdetails: [],
                          },
                        ],
                      });
                    }}
                  >
                    Add NOK
                  </Button>
                </Grid> */}

                {/* Bank Details Section */}
                <Grid item xs={12} spacing={3}>
                  <Typography variant="h6" gutterBottom>
                    Bank Details
                  </Typography>
                </Grid>

                {nok.bankdetails.map((bank, bankIndex) => (
                  <Grid container spacing={3} key={bankIndex}>
                    <Grid item xs={12} sm={6} >
                      <TextField
                        fullWidth
                        label="Bank Name"
                        value={bank.bankName}
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            bankIndex,
                            "bankName",
                            e.target.value
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Account No."
                        type="number"
                        value={bank.accountNo}
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            bankIndex,
                            "accountNo",
                            e.target.value
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Branch"
                        value={bank.branch}
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            bankIndex,
                            "branch",
                            e.target.value
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="IFSC Code"
                        value={bank.ifsc}
                        onChange={(e) =>
                          handleBankChange(
                            index,
                            bankIndex,
                            "ifsc",
                            e.target.value
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                ))}

                {/* Add Bank Details Button */}
                {/* <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      const updatedNOK = [...formData.NOK];
                      updatedNOK[index].bankdetails.push({
                        bankName: "",
                        accountNo: "",
                        branch: "",
                        ifsc: "",
                      });
                      setFormData({ ...formData, NOK: updatedNOK });
                    }}
                  >
                    Add Bank Details
                  </Button>
                </Grid> */}
              </Grid>
            ))}

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Rank
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <InputLabel>Rank</InputLabel>
                  <Select
                    name="rankname"
                    value={formData.rankname}
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select Rank</MenuItem>
                    {ranks
                      .sort((a, b) => a.rankname.localeCompare(b.rankname))
                      .map((rank) => (
                        <MenuItem key={rank._id} value={rank.rankname}>
                          {rank.rankname}
                        </MenuItem>
                      ))}
                  </Select>

                  {/* Show appropriate message based on loading state and conditions */}
                  {/* Show appropriate message based on loading state and conditions */}
                  {formData.rankname && !formData.uploadedDocuments?.length && (
                    <>
                      {requiredDocumentsLoading ? (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Loading required documents...
                        </Typography>
                      ) : requiredDocuments.length > 0 ? (
                        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                          ✅ Please upload required crew documents.
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                          <Typography variant="body2" color="error">
                            ❌ Please update rank.
                          </Typography>

                          {/* ✅ Show Edit Button Only for Admin */}
                          {userType === "admin" &&
                            ranks
                              // Ensure unique rank entries
                              .filter(
                                (rank, index, self) =>
                                  index ===
                                  self.findIndex((r) => r.rankname === rank.rankname) &&
                                  rank.rankname === formData.rankname
                              )
                              .map((rank) => (
                                <IconButton
                                  key={rank._id}
                                  color="primary"
                                  onClick={() => handleEdit(rank._id, rank.rankname)}
                                  sx={{ ml: 1 }}
                                >
                                  <EditIcon />
                                </IconButton>
                              ))}
                        </Box>
                      )}
                    </>
                  )}

                </FormControl>
              </Grid>
            </Grid>

            {/* Document Upload Section */}
          {requiredDocuments.length > 0 && (
  <Box sx={{ mt: 4 }}>
    <Typography variant="h6" gutterBottom>
      Upload Required Documents
    </Typography>
    <Grid container spacing={3}>
      {requiredDocuments.map((docKey) => (
        <Grid item xs={12} sm={6} key={docKey}>
          {/* Display name formatted, but keep key intact */}
          <Typography variant="body1" sx={{ mb: 1 }}>
            {formatDocumentName(docKey)}
          </Typography>

          <TextField
            fullWidth
            type="file"
            name={docKey}
            onChange={handleFileChange}
            InputLabelProps={{ shrink: true }}
            required={!crewProfileID}
          />

          {/* ✅ Use original key for checking existing documents */}
          {formData[docKey] &&
            typeof formData[docKey] === "object" &&
            formData[docKey].filePath && (
              <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
                <Typography variant="body2" color="text.secondary">
                  Current document: {formatDocumentName(docKey)}
                </Typography>
                <a
                  href={formData[docKey].filePath}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    marginLeft: "8px",
                    color: "#1976d2",
                    textDecoration: "none",
                  }}
                >
                  View {formatDocumentName(docKey)}
                </a>
              </Box>
            )}
        </Grid>
      ))}
    </Grid>
  </Box>
)}


            {/* Submit Button */}
            <Box sx={{ mt: 4, textAlign: "right" }}>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </Box>
          </form>
        </Paper>
      </Container>


      <ToastContainer />
    </>
  );
};

export default CrewProfile;
